<div class="col-span-12 md:col-span-6">
  <div class="flex justify-start items-center space-x-1 mb-2">
    <span *ngIf="required" class="text-lg text-red-500 font-bold mr-1">*</span>
    <label [for]="controlName" class="text-sm font-medium text-gray-700 dark:text-primary-100">{{ label }}</label>
  </div>

  <select
    [id]="controlName"
    [formControlName]="controlName"
    [required]="required"
    class="input"
  >
    <option selected value="" disabled>{{ placeholder }}</option>
    <option *ngFor="let option of options" [value]="option.id">{{ option.name }}</option>
  </select>

  <div class="pt-1" *ngIf="formControl.touched && formControl.invalid">
    <div class="ng-invalid input-error" *ngIf="formControl.errors?.['required']">
      {{ label }} field is required.
    </div>
  </div>
</div>
